"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3091],{

/***/ 93091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zb": function() { return /* reexport */ Card_Card; },
  "HW": function() { return /* reexport */ CardAsset; },
  "q4": function() { return /* reexport */ CardSkeleton; }
});

// UNUSED EXPORTS: CardContentA, CardContentB, CardContentC, CardContentE

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/Card/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_card_background_color",
                label: "Background color",
                type: "color",
                default: theme.palette.background.paper
            },
            {
                name: "theme_component_card_border_radius",
                label: "Border radius",
                type: "number",
                endAdornment: "px",
                default: theme.shape.borderRadius
            },
            {
                name: "theme_component_card_box_shadow",
                label: "Box shadow",
                type: "text",
                default: theme.shadows[3]
            },
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Content"
            },
            {
                name: "theme_component_card_content_border",
                label: "Border",
                placeholder: "1px solid #fff",
                type: "text",
                default: "none"
            },
            {
                name: "theme_component_card_content_button_color",
                label: "Button label color",
                type: "color",
                default: theme.palette.text.primary
            },
            {
                name: "theme_component_card_content_button_background",
                label: "Button background",
                type: "color",
                default: theme.palette.common.white
            },
            {
                name: "theme_component_card_content_button_hover_background_color",
                label: "Button hover background color",
                type: "color",
                default: theme.palette.action.hover
            },
            {
                name: "theme_component_card_content_button_active_background_color",
                label: "Button active background color",
                type: "color",
                default: theme.palette.action.active
            }, 
        ],
        configuration: [
            {
                name: "component_card_width",
                label: "Width",
                type: "number",
                endAdornment: "px",
                default: 512,
                helperText: "Specify the width of your card. The card remains responsive, but based on the width and height; an aspect ratio will be set."
            },
            {
                name: "component_card_height",
                label: "Height",
                type: "number",
                default: 288,
                endAdornment: "px"
            },
            {
                name: "component_game_carousel_card_type",
                label: "Card Type",
                type: "select",
                default: "simple",
                options: [
                    "default",
                    "simple",
                    "extensive",
                    "partial",
                    "big"
                ]
            }, 
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardActionArea/CardActionArea.js + 1 modules
var CardActionArea = __webpack_require__(9974);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./src/components/ImageLoaderWrapper/index.ts + 1 modules
var ImageLoaderWrapper = __webpack_require__(62430);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardMedia/CardMedia.js + 1 modules
var CardMedia = __webpack_require__(83965);
;// CONCATENATED MODULE: ./src/components/Card/CardAsset.tsx








var CardMediaStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(function(_param) /*#__PURE__*/ {
    var innerFlexSize = _param.innerFlexSize, other = (0,_object_without_properties/* default */.Z)(_param, [
        "innerFlexSize"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardMedia/* default */.Z, (0,_object_spread/* default */.Z)({}, other));
}, {
    target: "efn99i20"
})(function(param) {
    var theme = param.theme, _innerFlexSize = param.innerFlexSize, innerFlexSize = _innerFlexSize === void 0 ? "auto" : _innerFlexSize;
    return (0,_define_property/* default */.Z)({
        width: "100%",
        height: "auto",
        backgroundColor: theme.palette.grey["900"],
        pointerEvents: "none",
        marginBottom: "auto",
        "& span:first-of-type": {
            display: "block !important"
        },
        flex: innerFlexSize
    }, theme.breakpoints.down("md"), {
        flex: "auto"
    });
});
var CardAsset = function(props) {
    var width = props.width, height = props.height, className = props.className, innerFlexSize = props.innerFlexSize, other = (0,_object_without_properties/* default */.Z)(props, [
        "width",
        "height",
        "className",
        "innerFlexSize"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardMediaStyled, {
        className: className,
        innerFlexSize: innerFlexSize,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            style: {
                display: "block",
                position: "relative",
                aspectRatio: "".concat(width / height)
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageLoaderWrapper/* ImageLoaderWrapper */.T, (0,_object_spread/* default */.Z)({
                width: width,
                height: height
            }, other))
        })
    });
};

// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
;// CONCATENATED MODULE: ./src/components/Card/CardContentA.tsx









var CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "e1e8ztf40"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        "&:last-child": {
            paddingBottom: theme.spacing(1)
        }
    };
});
var getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};
var CardContentA_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled. Had trouble extending our CardContentAProps...
var CardContentA = function(props) {
    var title = props.title, limit = props.limit, className = props.className, other = (0,_object_without_properties/* default */.Z)(props, [
        "title",
        "limit",
        "className"
    ]);
    var captionRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentStyled, {
            className: className,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentA_Typography, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: captionRef,
                sx: {
                    width: "100%",
                    display: "inline-block"
                },
                variant: "caption",
                component: "span",
                noWrap: true
            }, other), {
                children: getText(title, limit || 35)
            }))
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CardContentB.tsx









var CardContentB_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "e1k8u2y20"
})(function(param) {
    var theme = param.theme;
    return {
        position: "relative",
        zIndex: 2,
        display: "flex",
        flexDirection: "column-reverse",
        justifyContent: "flex-end",
        alignItems: "center",
        height: "100%",
        borderTop: "none",
        pointerEvents: "none",
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        "&:last-child": {
            paddingBottom: theme.spacing(2)
        }
    };
});
var CardContentB_getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};
var CardContentB_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled. Had trouble extending our CardContentBProps...
var CardContentB = function(props) {
    var title = props.title, limit = props.limit, className = props.className, other = (0,_object_without_properties/* default */.Z)(props, [
        "title",
        "limit",
        "className"
    ]);
    var captionRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentB_CardContentStyled, {
            className: className,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentB_Typography, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: captionRef,
                sx: {
                    width: "100%",
                    display: "inline-block"
                },
                variant: "caption",
                color: "textPrimary",
                component: "p",
                noWrap: true
            }, other), {
                children: CardContentB_getText(title, limit || 35)
            }))
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
;// CONCATENATED MODULE: ./src/components/Card/CardContentC.tsx












var CardContentC_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentC_Button = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Button/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentC_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "eclqiin0"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "none"
    }, theme.breakpoints.up("sm"), {
        position: "relative",
        zIndex: 2,
        display: "flex",
        flexDirection: "column-reverse",
        justifyContent: "flex-end",
        alignItems: "center",
        height: "100%",
        textAlign: "center",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none"
    });
});
var Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentC_Typography, {
    target: "eclqiin1"
})(function(param) {
    var theme = param.theme;
    return {
        marginTop: theme.spacing(2),
        height: "80px"
    };
});
var ButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentC_Button, {
    target: "eclqiin2"
})(function(param) {
    var theme = param.theme;
    return {
        display: "inline-block",
        width: "auto",
        height: "auto",
        margin: 0,
        marginTop: theme.spacing(-3.5),
        padding: theme.spacing(0.5, 2),
        borderRadius: "100px",
        border: "1px solid #ebebeb",
        color: theme.theme_component_card_content_button_color || theme.palette.primary.contrastText,
        background: theme.theme_component_card_content_button_background || theme.palette.primary.main
    };
});
var CardContentC_getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled (now we have them hardcoded in our jsx).
//       Had trouble extending our CardContentCProps...
var CardContentC = function(props) {
    var description = props.description, limit = props.limit, className = props.className, other = (0,_object_without_properties/* default */.Z)(props, [
        "description",
        "limit",
        "className"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)("card_content_c").t;
    var body2Ref = react.useRef(null);
    var buttonRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContentC_CardContentStyled, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: body2Ref,
                variant: "body2",
                component: "p",
                color: "textPrimary"
            }, other), {
                children: description && CardContentC_getText(description, limit || 85)
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonStyled, {
                ref: buttonRef,
                variant: "contained",
                disableElevation: true,
                disableRipple: true,
                disableFocusRipple: true,
                size: "small",
                children: t("play_now", "Play now")
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 5 modules
var AppContext = __webpack_require__(24911);
;// CONCATENATED MODULE: ./src/components/Card/CardContentE.tsx





var CardCarousel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kzlu9v0"
})(function() {
    return {
        position: "absolute",
        top: 0,
        left: 0,
        transition: "transform 0.2s cubic-bezier(0.5, 0, 0.1, 1)",
        cursor: "pointer"
    };
});
var CarouselCardContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kzlu9v1"
})(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(0.5),
        height: "100%"
    };
});
var CarouselCardCover = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("img", {
    target: "e1kzlu9v2"
})(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: theme.palette.grey["900"],
        width: "100%",
        height: "100%",
        borderRadius: theme.spacing(1),
        boxSizing: "border-box",
        border: "1px solid transparent",
        " -webkit-box-shadow": "0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12),\n    0 1px 3px 0 rgba(0, 0, 0, 0.2)",
        boxShadow: "0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2);",
        "-moz-box-shadow": "0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2)"
    };
});
var CardContentE = function(props) {
    var game = props.game, width = props.width, height = props.height, pointX = props.pointX, pointY = props.pointY;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var assetUrl = appContext.useConfig().assetUrl;
    var scaleTimeout;
    var onMouseEnter = function(e) {
        var _target = e.target;
        while(_target.classList[0] !== "card-carousel"){
            // @ts-ignore
            _target = _target.parentNode;
        }
        var _cover = _target.querySelector(".carousel-card-cover");
        // @ts-ignore
        _cover.style.border = "2px solid aqua";
        if (_target.style.width !== "364px") {
            scaleTimeout = setTimeout(function() {
                // @ts-ignore
                _target.style.zIndex = 1;
                _target.style.transform = _target.style.transform + " scale(1.2)";
            }, 400);
        }
    };
    var onMouseLeave = function(e) {
        clearTimeout(scaleTimeout);
        var _target = e.target;
        while(_target.classList[0] !== "card-carousel"){
            // @ts-ignore
            _target = _target.parentNode;
        }
        _target.style.transform = _target.style.transform.replace(" scale(1.2)", "");
        // @ts-ignore
        _target.style.zIndex = null;
        var _cover = _target.querySelector(".carousel-card-cover");
        // @ts-ignore
        _cover.style.border = null;
        // @ts-ignore
        _cover.style.borderRadius = null;
    };
    if (!game) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardCarousel, {
        className: "card-carousel",
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        style: {
            width: "".concat(width, "px"),
            height: "".concat(height, "px"),
            transform: "translateX(".concat(pointX, "px) translateY(").concat(pointY, "px)")
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselCardContent, {
            className: "carousel-card-content",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                href: {
                    pathname: "/game/[slug]",
                    query: {
                        slug: game.slug
                    }
                },
                title: (game === null || game === void 0 ? void 0 : game.name) || undefined,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselCardCover, {
                    className: "carousel-card-cover",
                    src: "".concat(assetUrl).concat(game.images.cover16x9 || game.images.cover, "/")
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CardContentF.tsx












var CardContentF_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentF_Button = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Button/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentF_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "e1vppp510"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        paddingBottom: "".concat(theme.spacing(1), " !important"),
        width: "100%"
    }, theme.breakpoints.up("sm"), {
        position: "relative",
        zIndex: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        textAlign: "left",
        padding: theme.spacing(1.5, 2),
        height: "100%",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none"
    });
});
var CardContentF_Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentF_Typography, {
    target: "e1vppp511"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        height: "auto"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
        minHeight: "140px"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
        height: "60px"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), (0,_define_property/* default */.Z)({}, theme.breakpoints.down("lg"), {
        height: "70px"
    })), _obj;
});
var CardContentF_ButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentF_Button, {
    target: "e1vppp512"
})(function(param) {
    var theme = param.theme;
    return {
        display: "inline-block",
        width: "82px",
        height: "42px",
        margin: 0,
        marginTop: theme.spacing(1.5),
        padding: theme.spacing(0),
        borderRadius: "8px",
        border: "1px solid #ebebeb",
        fontSize: "16px",
        fontWeight: "bold",
        color: theme.theme_component_card_content_button_color || theme.palette.primary.contrastText,
        background: theme.theme_component_card_content_button_background || theme.palette.primary.main
    };
});
var CardContentF_getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled (now we have them hardcoded in our jsx).
//       Had trouble extending our CardContentCProps...
var CardContentF = function(props) {
    var description = props.description, title = props.title, limit = props.limit, className = props.className, other = (0,_object_without_properties/* default */.Z)(props, [
        "description",
        "title",
        "limit",
        "className"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)("card_content_c").t;
    var body2Ref = react.useRef(null);
    var buttonRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContentF_CardContentStyled, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentF_Typography, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                sx: {
                    width: "100%",
                    display: "inline-block",
                    paddingBottom: "12px",
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "#000"
                },
                variant: "caption",
                component: "span",
                noWrap: true
            }, other), {
                children: CardContentF_getText(title || "", limit || 35)
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentF_Description, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: body2Ref,
                variant: "body2",
                component: "p",
                color: "textPrimary"
            }, other), {
                children: description && CardContentF_getText(description, limit || 130)
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentF_ButtonStyled, {
                ref: buttonRef,
                variant: "contained",
                disableElevation: true,
                disableRipple: true,
                disableFocusRipple: true,
                size: "small",
                children: t("play_now", "Play")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CardContentBanner.tsx











var CardContentBanner_Button = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Button/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentBanner_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent/* default */.Z, {
    target: "e9ri2380"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        alignItems: "flex-start",
        textAlign: "left",
        width: "100%",
        height: "100%",
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        "&:last-child": {
            paddingBottom: theme.spacing(1)
        }
    };
});
var CardWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentBanner_Button, {
    target: "e9ri2381"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "30%"
    }, theme.breakpoints.down("md"), {
        alignItems: "normal",
        width: "auto"
    });
});
var CardContentBanner_ButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentBanner_Button, {
    target: "e9ri2382"
})(function(param) {
    var theme = param.theme;
    return {
        display: "inline-block",
        width: "82px",
        height: "42px",
        margin: 0,
        padding: theme.spacing(0),
        borderRadius: "8px",
        border: "1px solid #B1B1B1",
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(1),
        fontSize: "16px",
        fontWeight: "bold",
        color: theme.theme_component_card_content_button_color || theme.palette.primary.contrastText,
        background: theme.theme_component_card_content_button_background || theme.palette.primary.main
    };
});
var CardContentBanner_getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};
var CardContentBanner_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled. Had trouble extending our CardContentAProps...
var CardContentBanner = function(props) {
    var title = props.title, description = props.description, limit = props.limit, className = props.className, other = (0,_object_without_properties/* default */.Z)(props, [
        "title",
        "description",
        "limit",
        "className"
    ]);
    var captionRef = react.useRef(null);
    var buttonRef = react.useRef(null);
    var t = (0,useTranslation/* useTranslation */.$)("card_content_banner").t;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardWrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentBanner_CardContentStyled, {
                    className: className,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentBanner_Typography, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        ref: captionRef,
                        sx: {
                            width: "100%",
                            display: "inline-block",
                            fontWeight: "bold",
                            fontSize: "18px",
                            color: "#000"
                        },
                        variant: "caption",
                        component: "span",
                        noWrap: true
                    }, other), {
                        children: CardContentBanner_getText(title, limit || 35)
                    }))
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentBanner_CardContentStyled, {
                    className: className,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentBanner_Typography, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        ref: captionRef,
                        sx: {
                            width: "100%",
                            display: "inline-block",
                            whiteSpace: "normal"
                        },
                        variant: "caption",
                        color: "textPrimary",
                        component: "span",
                        noWrap: true
                    }, other), {
                        children: description
                    }))
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentBanner_ButtonStyled, {
                    ref: buttonRef,
                    variant: "contained",
                    disableElevation: true,
                    disableRipple: true,
                    disableFocusRipple: true,
                    size: "small",
                    children: t("play_now", "Play")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Card/Card.tsx



















var CardStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Card/* default */.Z, {
    target: "ejnpo760"
})(function(param) {
    var theme = param.theme, template = param.template, hoverEffect = param.hoverEffect, cardBorder = param.cardBorder;
    return {
        width: "100%",
        height: "100%",
        backgroundColor: theme.theme_component_card_background_color || theme.palette.background.paper,
        boxShadow: theme.theme_component_card_box_shadow || theme.shadows[3],
        borderRadius: template === "big" ? 0 : "".concat(theme.theme_component_card_border_radius, "px") || 0,
        border: cardBorder || "".concat(theme.theme_component_card_content_border, "px") || 0,
        borderStyle: theme.theme_component_card_content_border ? "solid" : "none",
        borderColor: theme.theme_component_card_content_border ? "#B1B1B1" : "none",
        transition: "transform ".concat(theme.transitions.duration.shortest, "ms ").concat(theme.transitions.easing.easeInOut),
        "&:hover": hoverEffect && {
            transform: "scale3d(1.05, 1.05, 1)"
        }
    };
});
var Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ejnpo761"
})(function(param) {
    var theme = param.theme, _innerFlex = param.innerFlex, innerFlex = _innerFlex === void 0 ? "column" : _innerFlex, _innerAlign = param.innerAlign, innerAlign = _innerAlign === void 0 ? "normal" : _innerAlign;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        flexDirection: innerFlex,
        alignItems: innerAlign,
        height: "100%"
    }, theme.breakpoints.down("md"), {
        flexDirection: "column"
    });
});
var Card_Card = function(props) {
    var href = props.href, src = props.src, width = props.width, height = props.height, alt = props.alt, template = props.template, title = props.title, description = props.description, className = props.className, sx = props.sx, typographyOptions = props.typographyOptions, hoverEffect = props.hoverEffect, innerFlex = props.innerFlex, innerFlexSize = props.innerFlexSize, cardBorder = props.cardBorder, other = (0,_object_without_properties/* default */.Z)(props, [
        "href",
        "src",
        "width",
        "height",
        "alt",
        "template",
        "title",
        "description",
        "className",
        "sx",
        "typographyOptions",
        "hoverEffect",
        "innerFlex",
        "innerFlexSize",
        "cardBorder"
    ]);
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var componentOptions = appContext.useConfig().componentOptions;
    var x = width || componentOptions.component_card_width || 100;
    var y = height || componentOptions.component_card_height || 100;
    var CommonCardContainer = function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            elevation: 0,
            className: className,
            sx: sx,
            hoverEffect: hoverEffect,
            template: template,
            cardBorder: cardBorder
        }, useEditorHandlers("Card")), {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardActionArea/* default */.Z, {
                component: Link/* Link */.r,
                href: href || "/",
                sx: {
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inner, {
                    innerFlexSize: innerFlexSize,
                    innerFlex: innerFlex,
                    style: {
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardAsset, (0,_object_spread/* default */.Z)({
                            innerFlexSize: innerFlexSize,
                            src: src,
                            width: x,
                            height: y,
                            alt: alt
                        }, other)),
                        children
                    ]
                })
            })
        }));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: {
            default: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonCardContainer, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentA, (0,_object_spread/* default */.Z)({
                    title: title,
                    description: description
                }, typographyOptions))
            }),
            simple: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonCardContainer, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentB, (0,_object_spread/* default */.Z)({
                    title: title
                }, typographyOptions))
            }),
            extensive: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonCardContainer, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentC, (0,_object_spread/* default */.Z)({
                    description: description
                }, typographyOptions))
            }),
            big: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonCardContainer, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {})
            }),
            cnn: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonCardContainer, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentF, (0,_object_spread/* default */.Z)({
                    title: title,
                    description: description
                }, typographyOptions))
            }),
            banner: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonCardContainer, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentBanner, (0,_object_spread/* default */.Z)({
                    title: title,
                    description: description
                }, typographyOptions))
            }),
            partial: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentE, (0,_object_spread/* default */.Z)({
                width: width,
                height: height
            }, other))
        }[template || "default"]
    });
};

// EXTERNAL MODULE: ./src/components/PaperColorElevation/index.ts + 1 modules
var PaperColorElevation = __webpack_require__(80830);
;// CONCATENATED MODULE: ./src/components/Card/CardSkeleton.tsx




var CardSkeletonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "e17ommov0"
})(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        height: "100%",
        borderRadius: theme.theme_component_card_border_radius || theme.shape.borderRadius,
        backgroundColor: theme.theme_component_card_background_color || theme.palette.background.paper
    };
});
var CardSkeleton = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSkeletonStyled, (0,_object_spread/* default */.Z)({}, props));
};

;// CONCATENATED MODULE: ./src/components/Card/index.ts









/***/ })

}]);